const config = {};
config.IS_BET = false;
config.webTitle = "Rajasthan Royals Predictor";
config.lang = {
  English: "en",
};
config.isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
config.enumClientIds = {
  FB: 1,
  TW: 2,
  EM: 3,
  PH: 4,
};

config.tourId = 3;

config.enumPlatformForMenu = {
  mobile: 1,
  desktop: 2,
  both: 3,
};

config.IsRedirectToListing = false;

config.displayPerA = 50;
config.displayPerB = 50;
// Swiper Required Params starts
config.swiperContainerClass = "swiper";
config.slidesPerViewMobile = 1;
config.slidesPerViewDesktop = 3;
config.simulateTouchMove = false;
config.simulateTouchMove = false;
config.swiperPagination = {
  el: ".swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal",
  type: "bullets",
  clickable: true,
};

config.lang2D = Object.keys(config.lang).map((key) => {
  return config.lang[key];
});
config.defaultLanguage = "en";
config.CURRENT_LANGUAGE = config.defaultLanguage;
let splitUrl = window.location.href.split("?lang=");
let subURL = splitUrl && splitUrl.length > 1 ? splitUrl[1] : null;
if (subURL && subURL.length) {
  let possibleLang = subURL.split("&").filter(Boolean)[0];
  if (config.lang2D.indexOf(possibleLang) > -1) {
    config.CURRENT_LANGUAGE = possibleLang;
  } else {
    config.CURRENT_LANGUAGE = config.defaultLanguage;
  }
}
config.toastMsgInterval = 1900;
config.homeTeamId = 1110;

// Game cookie
config.COOKIE_FANTASY = "rrpred_RAW";
config.COOKIE_007 = "rrpred_007";
config.COOKIE_GUID = "prpred_guid";
config.headers = { entity: "d3tR0!t5m@sh" };
config.ImgVersion = 5.33;
config.enumLoginCookie = {
  bothNotPresent: 1,
  fifaPresent: 2,
  fantasyPresent: 3,
  bothPresent: 4,
};
let location = window.location.href;

config.APPEND_GAMES = "/games";

if (location.indexOf("sportz.io") > -1) {
  config.BASE_DOMAIN = "/predictor/";
  config.API_BASE = config.BASE_DOMAIN;
  config.STATIC_ASSETS_APPEND = "/static-assets";
  config.IMG_BASE =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "assets/build/images/";
  config.IMG_TEAM = config.IMG_BASE + `flags/{{teamId}}.png`;

  // Player Image
  config.IMG_PLAYER = config.IMG_BASE + `playerImages/{{assetId}}.png`;

  // Player Image 2
  // config.IMG_PLAYER =
  //   config.IMG_BASE + `playerImages/10172.png?v=${config.ImgVersion}`;

  config.IMG_OVERLAY_TEAM = config.IMG_BASE + "flags/overlay/{{teamId}}.png";
  config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}.png";
  config.DefaultFlagImagesURL = config.IMG_TEAM.replace("{TeamId}", "Default");
  config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
  config.IMG_CARD = config.IMG_PITCH;
  config.DEFAULT_IMG_CARD = config.IMG_CARD.replace("{{playerId}}", "default");
  config.IMG_TOPFILTREPLAYER =
    config.IMG_BASE + "players/playerfiltertop/S_{{playerId}}.png";
  config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
  config.URL_BASE = config.APPEND_GAMES + config.BASE_DOMAIN;

  config.ACCOUNTS_API_BASE =
    config.APPEND_GAMES + config.BASE_DOMAIN + "services/api/";

  // API endpoint ...
  // config.ACCOUNTS_API_BASE =
  //   config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "feeds/live/";

  // S3 Feeds feeds/live ....
  config.ACCOUNTS_API_BASE_S3 =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "feeds/live/";

  // S3 Feeds feeds/static ....
  config.ACCOUNTS_API_BASE_S3_STATIC =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "feeds/static/";

  config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE;
  // config.LEADERBOARD_API_BASE = config.ACCOUNTS_API_BASE;
  config.LEADERBOARD_API_BASE =
    config.ACCOUNTS_API_BASE_S3_STATIC + "leaderboard/";
  config.generateImagePath =
    config.API_BASE + "services/image/{guid}/{lang}/generate?download={bool}";
  config.sDomain = window.location.hostname;
  config.FC_Home = "https://fancode.com/";
  config.FC_LoginLink =
    "https://fancodedev.com/login?utm_source=replay&utm_medium=click&utm_campaign=replaylogin&redirectUrl={{url}}";
  config.FC_RedirectLink =
    "https://rewindfantasy-int.fancode.com/user/fc-login-validate?redirect={{cbUrl}}";
  config.accountId = "6054721009001";
  config.howtoPlayLink = "https://rewindfantasy-int.fancode.com/more/howtoplay";
  config.tncLink =
    "https://rewindfantasy-int.fancode.com/more/termsandconditions";
} else if (location.indexOf(":300") > -1) {
  config.BASE_DOMAIN = "/";
  config.API_BASE = config.BASE_DOMAIN;
  config.STATIC_ASSETS_APPEND = "/static-assets";
  config.IMG_BASE =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "images/";
  config.IMG_TEAM = config.IMG_BASE + `flags/{{teamId}}.png`;

  // Player Image
  config.IMG_PLAYER = config.IMG_BASE + `playerImages/{{assetId}}.png`;
  config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}_3x.png";
  config.DefaultFlagImagesURL = config.IMG_TEAM.replace(
    "{{teamId}}",
    "Default"
  );
  config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
  config.IMG_CARD = config.IMG_PITCH;
  config.IMG_TOPFILTREPLAYER =
    config.IMG_BASE + "players/playerfiltertop/S_{{playerId}}.png";
  config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
  config.URL_BASE = "";
  config.ACCOUNTS_API_BASE = "https://rewindfantasy-int.fancode.com/services/";
  config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE + "ManageContest/";
  config.LEADERBOARD_API_BASE = config.ACCOUNTS_API_BASE + "Leaderboard/";
  config.sDomain = "dream11-loadtest-demo.sportz.io";
  config.FC_Home = "https://fancode.com/";
  config.FC_LoginLink =
    "https://fancodedev.com/login?utm_source=replay&utm_medium=click&utm_campaign=replaylogin&redirectUrl={{url}}";
  config.FC_RedirectLink =
    "https://rewindfantasy-int.fancode.com/user/fc-login-validate?redirect={{cbUrl}}";
  config.accountId = "6054721009001";
} else {
  config.BASE_DOMAIN = "/predictor/";
  config.API_BASE = config.BASE_DOMAIN;
  config.STATIC_ASSETS_APPEND = "/static-assets";
  config.IMG_BASE =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "assets/build/images/";

  config.IMG_TEAM = config.IMG_BASE + `flags/{{teamId}}.png`;

  // Player Image
  config.IMG_PLAYER = config.IMG_BASE + `playerImages/{{assetId}}.png`;

  // S3 Feeds feeds/live ....
  config.ACCOUNTS_API_BASE_S3 =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "feeds/live/";

  // S3 Feeds feeds/static ....
  config.ACCOUNTS_API_BASE_S3_STATIC =
    config.STATIC_ASSETS_APPEND + config.BASE_DOMAIN + "feeds/static/";

  config.IMG_OVERLAY_TEAM = config.IMG_BASE + "flags/overlay/{{teamId}}.png";
  config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}.png";
  config.DefaultFlagImagesURL = config.IMG_TEAM.replace("{TeamId}", "Default");
  config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
  config.IMG_CARD = config.IMG_PITCH;
  config.DEFAULT_IMG_CARD = config.IMG_CARD.replace("{{playerId}}", "default");
  config.IMG_TOPFILTREPLAYER =
    config.IMG_BASE + "players/playerfiltertop/S_{{playerId}}.png";
  config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
  config.URL_BASE = config.APPEND_GAMES + config.BASE_DOMAIN;
  config.ACCOUNTS_API_BASE =
    config.APPEND_GAMES + config.BASE_DOMAIN + "services/api/";
  config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE;
  // config.LEADERBOARD_API_BASE = config.ACCOUNTS_API_BASE;

  config.LEADERBOARD_API_BASE =
    config.ACCOUNTS_API_BASE_S3_STATIC + "leaderboard/";
  config.generateImagePath =
    config.API_BASE + "services/image/{guid}/{lang}/generate?download={bool}";
  config.sDomain = window.location.hostname;
  config.FC_Home = "https://fancode.com/";
  config.FC_LoginLink =
    "https://fancodedev.com/login?utm_source=replay&utm_medium=click&utm_campaign=replaylogin&redirectUrl={{url}}";
  config.FC_RedirectLink =
    "https://rewindfantasy-int.fancode.com/user/fc-login-validate?redirect={{cbUrl}}";
  config.accountId = "6054721009001";
  config.howtoPlayLink = "https://rewindfantasy-int.fancode.com/more/howtoplay";
  config.tncLink =
    "https://rewindfantasy-int.fancode.com/more/termsandconditions";
}

config.serverApiUrl = "https://time.akamai.com/?iso";
config.IS_MOBILE = window.innerWidth < 768;
config.IS_TABLET = window.innerWidth <= 768;

config.unAuthorizeUserRetval = -999;
config.Platform = { web: 3 };

config.GA_TRACKING_ID = window.GA_TRACKING_ID
  ? window.GA_TRACKING_ID
  : "G-PZWTYDGEF0"; // G-05GSS9RQGP

config.BrowserDetect = {
  Android: function () {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  iPAD: function () {
    return !!navigator.userAgent.match(/iPad/i);
  },
  Windows: function () {
    return !!navigator.userAgent.match(/IEMobile/i);
  },
  Windows_surface: function () {
    return !(
      !navigator.userAgent.match(/Trident/i) ||
      !navigator.userAgent.match(/Tablet/i)
    );
  },
  any: function () {
    return (
      config.BrowserDetect.Android() ||
      config.BrowserDetect.BlackBerry() ||
      config.BrowserDetect.iOS() ||
      config.BrowserDetect.Windows()
    );
  },
  ie9: function () {
    return !!navigator.userAgent.match(/MSIE 9.0/i);
  },
  ie10: function () {
    return !!navigator.userAgent.match(/MSIE 10.0/i);
  },
  ie: function () {
    return !(
      !navigator.userAgent.match(/MSIE/i) &&
      !navigator.userAgent.match(/Trident/i)
    );
  },
  FF: function () {
    return "undefined" != typeof InstallTrigger;
  },
  safari: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("crios") > -1) {
        return false; // Chrome
      } else {
        return true; // Safari
      }
    }
    // return !!navigator.userAgent.match(/Safari/i)
  },
};

config.enumStaticUrls = {
  home: "home",
  matches: "matches",
  upcoming: "liveandupcoming",
  result: "results",
  rules: "rules",
  terms: "terms",
  live: "live",
  leaderboard: "leaderboard",
  overall: "overall",
  weekly: "weekly",
  match: "match",
  more: "more",
  login: "login",
  create: "create",
  join: "join",
};

config.redirectDefault = `${config.URL_BASE}${config.enumStaticUrls.home}`;

config.enumBusters = {
  saveQuestion: "QUESTION_BUSTER",
  applyJoker: "APPLY_JOKER",
  saveLeague: "LEAGUE_BUSTER",
};

// CTA Specific
config.enumEventPage = {
  playNowBtn: {
    action: "homepage_redirection",
    category: "onboarding",
    label: "Homepage to Matches page redirection",
  },
  faqsBtn: {
    action: "homepage_redirection",
    category: "onboarding",
    label: "Homepage to FAQs page redirection",
  },
  rulesBtn: {
    action: "homepage_redirection",
    category: "onboarding",
    label: "Homepage to Rules page redirection",
  },
  leaderboardBtn: {
    action: "leaderboard_redirection",
    category: "matches_page",
    label: "Leaderboard Button Click on Completed Match Card",
  },
  viewPredictionClicked: {
    action: "taponviewprediction",
    category: "liveandupcomingtab",
    label: "MatchId : {{MatchId}}",
  },
  playerSelect: {
    action: "prediction_select",
    category: "prediction_gameplay",
    label: "Player Id {{optId}} Predicted for Question Id {{quesId}}",
  },
  timelineClick: {
    action: "question_select_timeline",
    category: "prediction_gameplay",
    label: "Question Selection on Timeline",
  },
  gameplayRank: {
    action: "rank_select",
    category: "prediction_gameplay",
    label: "Leaderboard Redirection from Gameplay Rank Button",
  },
  overallFilter: {
    action: "overall_select",
    category: "leaderboard",
    label: "Overall Filter Selection on Leaderboard",
  },
  matchesFilter: {
    action: "matches_select",
    category: "leaderboard",
    label: "Matches Filter Selection on Leaderboard",
  },
  specificMatchFilter: {
    action: "specific_match_select",
    category: "leaderboard",
    label: "Specific Match Filter Selection on Leaderboard",
  },
  selfRankClick: {
    action: "self_rank_click",
    category: "leaderboard",
    label: "Self Rank Click for Gameplay redirection",
  },
  homePageLoad: {
    action: "homepageloaded",
    category: "screen_load",
    label: "Home Page Loaded",
  },
  matches: {
    action: "matchespageloaded",
    category: "screen_load",
    label: "Matches Page Loaded",
  },
  leaderboard: {
    action: "leaderboardpageloaded",
    category: "screen_load",
    label: "Leaderboard Page Loaded",
  },
  rules: {
    action: "rulespageloaded",
    category: "screen_load",
    label: "Rules Page Loaded",
  },

  // ------------- Tracking starts here  ------------- //
  seeRulesClicked: {
    action: "seerulesclicked",
    category: "see_rules",
    label: "See Rules Clicked",
  },
  loginClicked: {
    action: "loginclicked",
    category: "login",
    label: "Login Clicked",
  },
  homePagePlayNowClicked: {
    action: "homepageplaynowclicked",
    category: "homepage_playnowclicked",
    label: "HomePage PlayNow Clicked",
  },
  liveandUpcomingClicked: {
    action: "liveandupcomingtabclicked",
    category: "live_and_upcomingtab",
    label: "Live And Upcoming Tab Clicked",
  },
  resultsClicked: {
    action: "resultstabclicked",
    category: "results_tab",
    label: "Results Tab Clicked",
  },
  questionsPageLoaded: {
    action: "questionpageloaded",
    category: "gameplay_screen",
    label: "Question Page Loaded",
  },
  questionOpened: {
    action: "questionopened",
    category: "gameplay_screen",
    label: "Question Opened {{jIndex}}",
  },
  jokerApplied: {
    action: "jokerused",
    category: "gameplay_screen",
    label: "jokerUsed on question id {{questionId}}",
  },
  jokerRemoved: {
    action: "jokerused",
    category: "gameplay_screen",
    label: "JokerRemoved on Question Id {{questionId}}",
  },
  predictionSelect: {
    action: "OptionSelected",
    category: "gameplay_screen",
    label: "Option Id {{optId}} Predicted for Question Id {{quesId}}",
  },
  backButtonClicked: {
    action: "backbuttonclicked",
    category: "gameplay_back",
    label: "Gameplay Back Button Clicked",
  },
  infoPopupOpened: {
    action: "infoclicked",
    category: "info_clicked",
    label: "Gameplay Info Opened",
  },
  infoPopupClosed: {
    action: "gameplaydone",
    category: "gameplay_done_clicked",
    label: "Gameplay Info Closed",
  },
  donePrediction: {
    action: "doneprediction",
    category: "done_prediction",
    label: "Prediction Done",
  },
  predictNowButtonClicked: {
    action: "predictnowclicked",
    category: "live_and_upcoming_tab",
    label:
      "Predict Now Button Clicked on Match ID {{id}} Match {{MatchdayName}}",
  },
  viewResultsButtonClicked: {
    action: "viewresultsclicked",
    category: "matches_results_page",
    label:
      "View Results Button Clicked on Match ID {{id}} Match {{MatchdayName}}",
  },
  editNowButtonClicked: {
    action: "editnowclicked",
    category: "live_and_upcoming_tab",
    label:
      "Your Predictions Button Clicked on Match ID {{id}} Match {{MatchdayName}}",
  },
  matchesLeaderboardClicked: {
    action: "matches_leaderboardtab_clicked",
    category: "matches_leaderboard",
    label: "Matches Leaderboard Tab Clicked",
  },
  overallLeaderboardClicked: {
    action: "overall_leaderboardtab_clicked",
    category: "overall_leaderboard",
    label: "Overall Leaderboard Tab Clicked",
  },
  matchesLeaderboardSelectedMatchDetails: {
    action: "editnowclicked",
    category: "matches_leaderboard",
    label: "Match Selected {{selectedMatch}}",
  },
};

// Page Specific
config.enumAnalyticsPages = {
  home: {
    sTitle: "homepageloaded",
    sPath: "/home",
  },
  matches: {
    sTitle: "matchespageloaded",
    sPath: "/matches/liveandupcoming",
  },
  leaderboard: {
    sTitle: "leaderboardpageloaded",
    sPath: "/leaderboard",
  },
  rules: {
    sTitle: "rulespageloaded",
    sPath: "/rules",
  },
};

config.enumFixtureType = {
  isUpcomming: 1,
  isLock: 2,
  isLive: 3,
  isFinished: 4,
  isAbandoned: 5,
  isEnded: 6,
  isOpen: 7,
};

config.enumErrorCode = { normal: 0, isToast: 1, isRedirect: 2 };
config.enumGameStatus = {
  open: 1,
  locked: 2,
  finished: 3,
};
config.enumGameMode = {
  live: 0,
  maintenance: 1,
  comingSoon: 2,
};
config.UserPlayedCount = 1;

config.isTbc = 1;
config.enumMatchStatus = { upcoming: [1], live: [2], result: [3] };
config.enumMatchStatus.upcomingLive = config.enumMatchStatus.upcoming.concat(
  config.enumMatchStatus.live
);
config.enumMatchStatus.upcomingLiveResult =
  config.enumMatchStatus.upcomingLive.concat(config.enumMatchStatus.result);

config.objTabs = {
  [config.enumStaticUrls.upcoming]: {
    trans: "games",
    matchStatus: config.enumMatchStatus.upcomingLive,
    noDataTrans: "noDataUpcoming",
  },
  // [config.enumStaticUrls.live]: { trans: 'live', matchStatus: config.enumMatchStatus.live, noDataTrans: 'noDataLive' },
  [config.enumStaticUrls.result]: {
    trans: "result",
    matchStatus: config.enumMatchStatus.result,
    noDataTrans: "noDataResult",
  },
};

config.enumHowToPlayContent = [
  {
    id: 1,
    imgUrl: config.IMG_BASE + `htp1.svg`,
    title: "stepOne",
    alt: "Step 1",
    subtitle: "makeYourPredictions",
    content: "stepOneContent",
  },

  {
    id: 2,
    imgUrl: config.IMG_BASE + `htp2.svg`,
    title: "stepTwo",
    alt: "Step 2",
    subtitle: "pickMatch",
    content: "stepTwoContent",
  },
  {
    id: 3,
    imgUrl: config.IMG_BASE + `htp3.svg`,
    title: "stepThree",
    alt: "Step 3",
    subtitle: "checkboard",
    content: "stepThreeContent",
  },
];

config.enumBulletsClassType = {
  isEmpty: 0,
  isAnswered: 1,
  isEmptyLocked: 2,
  isAnsweredLocked: 3,
  isCorrect: 4,
  isWrong: 5,
  isJokerApplied: 6,
};

config.enumBulletsClass = {
  [config.enumBulletsClassType.isEmpty]: {
    sClass: "",
    sClassIcon: "",
  },
  [config.enumBulletsClassType.isAnswered]: {
    sClass: "si-active",
    sClassIcon: "pd-correct",
  },
  [config.enumBulletsClassType.isEmptyLocked]: {
    sClass: "si-locked",
    sClassIcon: "rs-pre-lock",
  },
  [config.enumBulletsClassType.isAnsweredLocked]: {
    sClass: "si-locked",
    sClassIcon: "rs-pre-lock",
  },
  [config.enumBulletsClassType.isCorrect]: {
    sClass: "si-correct",
    sClassIcon: "rs-pre-tick",
  },
  [config.enumBulletsClassType.isWrong]: {
    sClass: "si-wrong",
    sClassIcon: "rs-pre-close",
  },
  [config.enumBulletsClassType.isJokerApplied]: {
    sClass: "si-twice",
    sClassIcon: "pd-cross",
  },
};

config.playerSkillId = {
  0: {
    SkillName: "NONE",
    SkillIconClass: "rs-pre-others",
  },
  1: {
    SkillName: "BATTER",
    SkillIconClass: "rs-pre-bat",
  },
  2: {
    SkillName: "BOWLER",
    SkillIconClass: "rs-pre-bowl",
  },
  3: {
    SkillName: "ALL ROUNDER",
    SkillIconClass: "rs-pre-all-rounder",
  },
  4: {
    SkillName: "WICKET KEEPER",
    SkillIconClass: "rs-pre-wicket-keeper",
  },
};

config.enumBoosters = {
  booster1: 1,
  booster2: 2,
};
config.redirectToLogin = `${config.URL_BASE}${config.enumStaticUrls.login}?ru={{ru}}`;
config.emptyValue = -1;
config.enumQuestionStatus = {
  unOpen: 0,
  open: 1,
  locked: 2,
  resolved: 3,
};
config.objPointsConstraints = {
  basePoints: 75,
  booster1: 2,
  booster2: 3,
  arrDetails: [
    { min: 0, max: 5, plusPoints: 12, minusPoints: 0 },
    { min: 0, max: 5, plusPoints: 12, minusPoints: 0 },
    { min: 6, max: 20, plusPoints: 9, minusPoints: 0 },
    { min: 21, max: 50, plusPoints: 7, minusPoints: 0 },
    { min: 51, max: 70, plusPoints: 4, minusPoints: 0 },
    { min: 71, max: -1, plusPoints: 2, minusPoints: 0 },
  ],
};

config.mixApiLiveInterval = 10000;
config.freezTime = 2000;

config.enumMixAPI = {
  fixture: "afix",
  questions: "aqus",
  leaderboard: "lb",
  leaderboardOverall: "lbov",
  leaderboardOverallTour: "lbtour",
};

config.enumLeaderboardFilter = {
  overall: 1,
  weekly: 2,
  match: 3,
  league: 4,
};
config.enumLeagueFilter = {
  create: 1,
};
config.parentCookie = "_URC";

config.enumCookieStatus = {
  onlyParent: 1,
  onlyChild: 2,
  both: 3,
  missMatch: 4,
  none: 0,
};
config.jTempQuestionId = -1000;
config.sAddBannerUrl = config.IMG_BASE + "card-ad.png";
config.sAddBannerUrlMob = config.IMG_BASE + "card-ad-mob.png";
config.sAddBannerUrl1 = config.IMG_BASE + "ad-desktop.jpg";
config.sAddBannerUrl2 = config.IMG_BASE + "ad-mobile.jpg";
config.leaderboardIncCount = 10;
config.enumTrend = {
  2: {
    class: "si-trend--up",
  },
  1: {
    class: "si-trend--eq",
  },
  0: {
    class: "si-trend--eq",
  },
  3: {
    class: "si-trend--dw",
  },
};
config.enumLeaderboardType = {
  // daily: "daily",
  // weekly: "weekly",
  gameday: "gameday",
  overall: "overall",
};
config.emptyValueLeaderboard = 0;
config.IS_WEBVIEW = false;
config.WEBVIEW_FLAG = "webview=true";
export default config;
